export const SURGERY_REQUEST_CONFLICT_MESSAGES = {
  ROOM: 'Операційна вже зайнята на обрану дату та час.',
  STAFF: 'Один або кілька учасників уже задіяні в іншій операції на обрану дату та час:',
} as const